import React, { Component } from "react";

export default class Price extends Component {
    render() {
        var raw = this.props.children;
        var output = "0"; // ändrat från =0 

        if (typeof raw == "string") {
            var number = raw.replace("&", "").replace(",", ".").replace(/[^0-9&.&]/g, "");
            var text = raw.replace(",", ".").replace(number, "");
            var append = (raw.indexOf(text) > 0);

            if (number.endsWith(".00")) {
                number = number.slice(0, -3);
            }

            if (parseInt(number)) {
                number = parseInt(number).toLocaleString();
            }

            if (append) {
                output = number + text;
            } else {
                output = text + number;
            }
        }

        if (output.includes("SEK") && !output.endsWith("SEK")) {
            output = output.slice(0, output.indexOf("SEK") + 3)
        }

        return <span className={this.props.className} dangerouslySetInnerHTML={{__html: output}}></span>
    }
}